
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"15","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M13.078 3.687l.876 6.15c.355 2.693-1.39 5.14-3.754 5.163H3.763C1.44 15-.325 12.53.05 9.838l.876-6.15C1.134 1.653 2.712.086 4.64 0h4.727c1.927.087 3.504 1.654 3.712 3.687zm-2.857 10.185a2.492 2.492 0 001.926-.981c.637-.8.914-1.856.757-2.891l-.855-6.15c-.122-1.502-1.265-2.68-2.683-2.766H4.639C3.22 1.17 2.077 2.348 1.955 3.85L1.1 10a3.755 3.755 0 00.758 2.89c.475.612 1.18.97 1.926.982h6.437z","fill":"#585858"}}),_c('path',{attrs:{"d":"M9.192 3.835c-.288 0-.521.247-.521.553 0 .977-.747 1.77-1.669 1.77-.921 0-1.668-.793-1.668-1.77 0-.306-.234-.553-.522-.553-.287 0-.52.247-.52.553 0 1.027.516 1.977 1.355 2.49a2.577 2.577 0 002.71 0c.84-.513 1.357-1.463 1.357-2.49-.004-.304-.235-.55-.522-.553z","fill":"#585858"}})])
          )
        }
      }
    